import Modal from "../shared/Modal";
import "./ModalDeleteSnippetConfirm.css";

type ModalDeleteSnippetConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalDeleteSnippetConfirm = ({
  isOpen,
  onClose,
  onContinue,
}: ModalDeleteSnippetConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-delete-snippet-confirm">
          <div className="modal-collection-delete-snippet-confirm-title">
            Delete this Snippet
          </div>

          <div className="modal-collection-delete-snippet-confirm-content">
            This snippet will be deleted for you and everyone in this workspace.
          </div>

          <div className="modal-collection-delete-snippet-confirm-footer">
            <div className="modal-collection-delete-snippet-confirm-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Continue with Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalDeleteSnippetConfirm;
